// extracted by mini-css-extract-plugin
module.exports = {"base":"MostVisitedLists_base__KeK6q","TutorialItemsWrapper":"MostVisitedLists_TutorialItemsWrapper__9dDmY"};